module.exports = __webpack_public_path__ + "img/11_61.9fcd29c8.png";